import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export interface AppointmentData {
  id: string;
  start_at: string;
  oncologist?: {
    name: string;
    surname: string;
  };
  nutrizionist?: {
    name: string;
    surname: string;
  };
  patient?: {
    name: string;
    surname: string;
  };
}

export const generateICSContent = (appointment: AppointmentData): string => {
  const startDate = dayjs(appointment.start_at);
  const endDate = startDate.add(50, "minutes"); // Assuming 50-minute appointments

  // Get doctor name
  const doctor = appointment.oncologist || appointment.nutrizionist;
  const doctorName = doctor ? `${doctor.name} ${doctor.surname}` : "Doctor";

  // Get patient name
  const patientName = appointment.patient
    ? `${appointment.patient.name} ${appointment.patient.surname}`
    : "Patient";

  // Format dates for ICS (YYYYMMDDTHHMMSSZ)
  const formatDateForICS = (date: dayjs.Dayjs) => {
    return date.utc().format("YYYYMMDDTHHmmss[Z]");
  };

  const uid = `appointment-${appointment.id}@inbuonasaluteapp.com`;
  const now = dayjs().utc().format("YYYYMMDDTHHmmss[Z]");

  const icsContent = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//In Buona Salute//Appointment//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${now}`,
    `DTSTART:${formatDateForICS(startDate)}`,
    `DTEND:${formatDateForICS(endDate)}`,
    `SUMMARY:Appuntamento con ${doctorName}`,
    `DESCRIPTION:Appuntamento medico con ${doctorName} per ${patientName}`,
    "STATUS:CONFIRMED",
    "SEQUENCE:0",
    "END:VEVENT",
    "END:VCALENDAR"
  ].join("\r\n");

  return icsContent;
};

export const downloadICSFile = (appointment: AppointmentData, filename?: string): void => {
  const icsContent = generateICSContent(appointment);
  const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename || `appointment-${dayjs(appointment.start_at).format("YYYY-MM-DD")}.ics`;

  // Trigger download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up
  URL.revokeObjectURL(url);
};
